<template>
  <div class="agreement-page">
    <h1>{{ $t('precautions') }}</h1>
    <h3>{{ title1 }}</h3>
    <pre>{{ agreement1 }}</pre>
    <h3>{{ title2 }}</h3>
    <pre>{{ agreement2 }}</pre>
    <h3>{{ title3 }}</h3>
    <pre>{{ agreement3 }}</pre>
    <!-- <pre v-html="agreement"></pre> -->
  </div>
</template>

<script>
import { agreement1, title1, title2, title3, agreement2, agreement3 } from '../../config/agreement'
export default {
  name: '',
  components: {},
  data() {
    return { agreement1, title1, title2, title3, agreement2, agreement3 }
  },
  mounted() { this.resetContent() },
  methods: {
    resetContent() {
      // ``字符串中换行替换为 <br/>
      // this.agreement = this.agreement.replace(/\n/g, '<br/>')
    }
  },
}

</script>
<style lang='scss' scoped>
.agreement-page {
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-y: auto;
  height: calc(100vh - 100px);
  height: calc(100svh - 100px);
  padding-bottom: 80px;
  box-sizing: border-box;
  overflow-y: auto;
h1{
  font-size: 26px;
  margin-bottom: 30px;
}
h3 {
    text-align: left;
    padding: 0 20px;
    margin: 0;
    margin-top: 18px;
    line-height: 34px;
    width: 100%;
    box-sizing: border-box;
  }
pre  {
    width: 100%;
    text-align: left;
    line-height: 28px;
    overflow: hidden;
    flex-shrink: 0;
    box-sizing: border-box;
    padding: 0 20px;
    margin: 0;
    word-break: break-all;
    white-space: pre-wrap;
  }
}
</style>
